import LogoLink from './LogoLink.js';
export default LogoLink;
//# sourceMappingURL=index.js.map